<template>
  <div 
    class="document-type-chip"
    :class="{ 
      'disabled-chip': disabled,
      'generating': isGenerating,
      'premium-chip': isPremium,
      'upload-chip': isUpload
    }"
    @click="handleGenerate"
  >
    <div class="chip-content">
      <i v-if="isUpload && !isGenerating" class="fas fa-plus upload-icon"></i>
      <span class="chip-title">{{ title }}</span>
      <b-spinner v-if="isGenerating" small class="generating-spinner"></b-spinner>
    </div>
  </div>
</template>

<script>
export default {
  name: "DocumentTypeCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isPremium: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "fas fa-file-alt",
    },
    isGenerating: {
      type: Boolean,
      default: false,
    },
    isUpload: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleGenerate() {
      if (!this.disabled && !this.isGenerating) {
        this.$emit("generate", this.value);
      }
    },
    getIconClass() {
      return this.icon;
    },
    getButtonText() {
      if (this.isGenerating) return "กำลังสร้าง...";
      return "สร้างเอกสาร";
    },
  },
  emits: ["generate"],
};
</script>

<style scoped>
.document-type-chip {
  display: inline-block;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 18px;
  padding: 0.5rem 1rem;
  margin: 0;
  cursor: pointer;
  transition: all 0.15s ease;
  position: relative;
  font-size: 0.8rem;
}

.document-type-chip:hover:not(.disabled-chip):not(.generating) {
  background: #007bff;
  border-color: #007bff;
  color: white;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.2);
}

.document-type-chip:hover:not(.disabled-chip):not(.generating) .chip-title {
  color: white;
}

.document-type-chip.disabled-chip {
  opacity: 0.4;
  cursor: not-allowed;
  background: #f1f3f4;
}

.document-type-chip.generating {
  background: rgba(40, 167, 69, 0.08);
  border-color: #28a745;
  color: #28a745;
}

.document-type-chip.upload-chip {
  background: #fafbfc;
  border: 2px dashed #dee2e6;
  color: #6c757d;
  border-radius: 8px;
}

.document-type-chip.upload-chip:hover:not(.disabled-chip):not(.generating) {
  background: #f8f9fa;
  border-color: #adb5bd;
  color: #495057;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.document-type-chip.upload-chip:hover:not(.disabled-chip):not(.generating) .chip-title {
  color: #495057;
}

.chip-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
}

.chip-title {
  font-weight: 500;
  color: #495057;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

.generating-spinner {
  flex-shrink: 0;
  width: 12px;
  height: 12px;
}

.upload-icon {
  font-size: 0.7rem;
  margin-right: 0.25rem;
  opacity: 0.7;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .document-type-chip {
    padding: 0.4rem 0.8rem;
    font-size: 0.75rem;
    border-radius: 16px;
  }
  
  .chip-content {
    gap: 0.25rem;
  }
}

@media (max-width: 576px) {
  .document-type-chip {
    padding: 0.35rem 0.7rem;
    font-size: 0.7rem;
    border-radius: 14px;
  }
  
  .generating-spinner {
    width: 10px;
    height: 10px;
  }
}
</style>